(function() {
  'use strict';

  function initCodButton() {
    const codBtn = document.querySelector('.btn-cod');
    if (!codBtn) return;

    codBtn.addEventListener('click', function() {
      const variantInput = document.querySelector('input[name="id"]');
      if (!variantInput) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: 1 })
      })
      .then(function(response) { return response.json(); })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() { window.location.href = '/checkout'; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCodButton);
  } else {
    initCodButton();
  }
})();